// src/CookieConsent.jsx
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import "./cookie.css";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = Cookies.get("cookieConsent");
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("cookieConsent", "accepted", { expires: 365 });
    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-wrapper">
      <div className="cookie-consent-banner">
        <div className="cookie-row">
          <p>
            <b>Folosim cookie-uri pentru a imbunatati experienta ta pe ContaLearn.</b> Afla mai multe despre{" "}
            <Link to="/politicacookies">politica de cookie-uri</Link>.
          </p>
          <button onClick={handleClose} className="close-btn-phone">
            ×
          </button>
        </div>

        <div className="cookie-actions">
          <button onClick={handleAccept} className="accept-btn">
            Accept
          </button>
            <button onClick={handleClose} className="close-btn-desktop">
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
